import React, { useContext, useEffect, useState } from 'react';
// import './PersonalityReport.css'
import LYWOLogoSmall from "../assets/images/LYWOLogoSmall.svg";
import { PostCallWithErrorResponse, simpleGetCallWithErrorResponse } from '../Api/ApiServices';
import { ApiConfig } from '../Api/ApiConfig';
import ReactMarkdown from "react-markdown";
import { useNavigate, useParams } from 'react-router-dom';
import { Spinner } from 'react-bootstrap';
import { toastMsg } from '../component/toast';
import CustomButton from '../component/button';
import { AppContext } from '../context/AppContext';
const candidateName = "Candidate Name";  // Change this dynamically


function NewDetailedPersonality() {

  const [html, setHtml] = useState('')

  const { adminData } = useContext(AppContext)

  const { code, userId } = useParams()

  const [userDetails, setUserDetails] = useState({})

  const [isLoading, setIsLoading] = useState(false)

  const navigate = useNavigate()

  const updateCreditLimit = () => {

    let payload = {
      "credit": 1,
      "type": "Detail Personality Report",
      "jobcode": code,
      "userId": userId
    }

    PostCallWithErrorResponse(ApiConfig.UPDATE_CREDIT, payload)

  }

  const savePersonalityReport = (report) => {

    const payload = {
      "userId": userId,
      "code": code,
      "personalityReport": report,
      Admin: adminData?.email
    }

    PostCallWithErrorResponse(ApiConfig.SAVE_PERSONALITY_REPORT, payload)

  }


  const getPersonalityReport = async () => {

    setIsLoading(true)


    let res = await simpleGetCallWithErrorResponse(ApiConfig.GET_SUMMARY_REPORT + `UserId=${userId}&Code=${code}`)

    if (!res?.json?.succeded) {
      toastMsg('error', res?.json?.message)
      return
    }

    setUserDetails(res?.json?.response)

    const { candidateName, traitsResult, personalityReport } = res?.json?.response

    if (personalityReport) {
      setHtml(personalityReport)
      setIsLoading(false)
      return
    }


    let payload = {
      "user_name": candidateName,
      "adapted_behaviour_traits": Object.values(traitsResult?.most),
      "natural_behaviour_traits": Object.values(traitsResult?.least),
      "overall_personality_traits": Object.values(traitsResult?.diff)
    }

    PostCallWithErrorResponse(ApiConfig.GENERATE_PEROSALITY_REPORT, payload).then((res) => {
      updateCreditLimit()
      savePersonalityReport(res?.json?.personality_report)
      setHtml(res?.json?.personality_report)

      setIsLoading(false)

    })

  }

  useEffect(() => {
    getPersonalityReport()
  }, [])

  return (
    <>


      {/* ==================== PAGE 1 - COVER ==================== */}
      <div className=' mt-2' style={{ marginLeft: '20px' }}>
        <CustomButton
          title="Back To Candidate List"
          buttonType='secondary'
          handleClick={() => navigate(-1)}
        />
      </div>
      <div className="page cover-page">

        <div className="header-logo">
          <div className="logo"><img src={LYWOLogoSmall} className="" alt="Logo" style={{
            width: "164px"
          }} />
          </div>
          <div className="logo-subtitle">Love Your Work</div>
        </div>

        <div className="main-title">
          {/* <h1>Detailed<br />Personality<br />Report</h1> */}

          <h1 className='heading-H1'>Detailed&nbsp;</h1>
          <br />
          <h1 className='heading-H1'>Personality&nbsp;</h1>
          <br />
          <h1 className='heading-H1'>Report&nbsp;</h1>
        </div>

        <div className="candidate-name-cover">{userDetails?.candidateName}</div>
        <div className="footer-note">
          For any queries email us at hello@lywo.in
        </div>

        <div className="bottom-blue-bar"></div>
      </div>



      {/* ==================== PAGE 2 ==================== */}
      <div className="page">
        {
          isLoading ?
            <>
              <div className='d-flex justify-content-center pt-4'>
                <Spinner animation="grow" variant="dark" />
              </div>
            </> :
            <div className="content">

              <div className="report-header">
                <h2>Behavioural Assessment Report</h2>
                <div className="logo-small">
                  <div className="logo"><img src={LYWOLogoSmall} className="" alt="Logo" style={{
                    width: "164px"
                  }} /></div>
                  <div className="logo-subtitle">Love Your Work</div>
                </div>
              </div>

              <h3 className="candidate-title">Detailed Personality Report: {userDetails?.candidateName}</h3>

              <ReactMarkdown>{html}</ReactMarkdown>

              {/* <p className="text-dark" style={{ marginTop: 0, marginBottom: "8pt", textAlign: "justify" }}>
            Atanu P Adhikari presents a dynamic personality shaped by a blend of curiosity, persuasive communication, spontaneity, and cautious deliberation. In work settings, he is likely to engage proactively with new ideas, leveraging his ability to explore and persuade others effectively. His natural decisiveness and preference for pleasant interactions are tempered by an undercurrent of restlessness and a desire for autonomy, which can lead to occasional frustration in structured environments. While he adapts to present himself as methodical and critical, his core tendencies reveal a genuine, independent thinker who values both exploration and careful execution. Supervisors should foster environments that balance structure with flexibility, allowing his inquisitive nature and restraint to mitigate impulsiveness.
          </p>

          <h4>Overall Personality</h4>
          <p className="text-dark" style={{ marginTop: 0, marginBottom: "8pt", textAlign: "justify" }}>
            Atanu’s overall demeanor is characterized by a unique interplay of curiosity, persuasive strength, spontaneity, and measured restraint. This blend suggests an individual who approaches challenges with a desire to understand deeply, articulate persuasively, and act with immediacy, albeit tempered by a cautious approach to decisions.
          </p>
          <p className="text-dark" style={{ marginTop: 0, marginBottom: "8pt", textAlign: "justify" }}>
            When compared to his adapted and natural behaviors, the most notable alignment lies in his consistent decisiveness and systematic approach. However, the heightened spontaneity in his overall behavior compared to his natural discontent suggests occasional internal tension. This could manifest in scenarios requiring prolonged patience, where his preference for action might clash with a deeper need for stability, potentially leading to frustration if changes are imposed without consultation.
          </p>
          <p className="text-dark" style={{ marginTop: 0, marginBottom: "8pt", textAlign: "justify" }}>
            A minor conflict arises between his persuasive confidence and restrained nature. While he can convincingly advocate for initiatives, his cautious side may cause hesitation in high-stakes situations, creating a push-pull dynamic. This duality could enhance his adaptability but may also demand additional time to reconcile assertiveness with deliberation.
          </p>
          <p className="text-dark" style={{ marginTop: 0, marginBottom: "8pt", textAlign: "justify" }}>
            Overall, Atanu thrives in roles that value exploration and adaptability but may find overly rigid structures stifling. His ability to pivot between enthusiasm and restraint makes him a collaborative asset, though environments with rapid, unstructured changes might amplify his spontaneity at the expense of thorough planning.
          </p>

          <h4>Self-Image</h4>
          <p className="text-dark" style={{ marginTop: 0, marginBottom: "8pt", textAlign: "justify" }}>
            Atanu adapts to present himself as a decisive, analytical, and systematic individual who occasionally embraces impulsiveness. This self-perception highlights a persona oriented toward structured problem-solving, marked by swift decision-making and a preference for methodical processes.
          </p>
          <p className="text-dark" style={{ marginTop: 0, marginBottom: "8pt", textAlign: "justify" }}>
            He likely views himself as a pragmatic strategist, capable of dissecting complex situations through critical analysis while maintaining a readiness to act swiftly when opportunities arise. This combination suggests a professional who values efficiency and order but can occasionally surprise peers with unexpected, energetic engagement.
          </p>
          <p className="text-dark" style={{ marginTop: 0, marginBottom: "8pt", textAlign: "justify" }}>
            The critical lens he adapts may lead him to scrutinize processes meticulously, ensuring thoroughness. However, an undercurrent of impulsiveness could sometimes undermine his systematic approach, creating moments where spontaneity overrides planning. This duality positions him as a dynamic contributor who balances reliability with adaptability, though he might occasionally struggle to align his quick decisions with long-term objectives.
          </p>

          <h4>The Natural Personality</h4>
          <p className="text-dark" style={{ marginTop: 0, marginBottom: "8pt", textAlign: "justify" }}>
            At his core, Atanu is a decisive and congenial individual driven by an independent spirit and a latent dissatisfaction with stagnation. This natural state reveals a person who combines assertive decision-making with a friendly demeanor, all while harboring a desire for progress and self-reliance.
          </p>
          <p className="text-dark" style={{ marginTop: 0, marginBottom: "8pt", textAlign: "justify" }}>
            His decisiveness emerges effortlessly in comfortable settings, allowing him to navigate challenges with confidence. A pleasant disposition ensures he collaborates amiably, fostering rapport without overt dominance. However, a discontented streak underscores his aversion to complacency, pushing him to question inefficiencies and seek improvements.
          </p>
          <p className="text-dark" style={{ marginTop: 0, marginBottom: "8pt", textAlign: "justify" }}>
            In stress or comfort, this natural blend might lead him to advocate for change proactively, though his discontent could manifest as restlessness if progress stagnates. Supervisors should recognize his self-driven nature as both a motivator and a potential source of friction in stagnant environments.However, a
          </p> */}
            </div>
        }
      </div>


      {/* <div className="page">
        <div className="content">
          <div className="report-header">
            <h2>Behavioural Assessment Report</h2>
            <div className="logo-small">
              <div className="logo"><img src={LYWOLogoSmall} className="" alt="Logo" style={{
                width: "164px"
              }} /></div>
              <div className="logo-subtitle">Love Your Work</div>
            </div>
          </div>
          <p className="text-dark" style={{ marginTop: 0, marginBottom: "8pt", textAlign: "justify" }}>
            discontented streak underscores his aversion to complacency, pushing him to question inefficiencies and seek improvements.
          </p>
          <p className="text-dark" style={{ marginTop: 0, marginBottom: "8pt", textAlign: "justify" }}>
            In stress or comfort, this natural blend might lead him to advocate for change proactively, though his discontent could manifest as restlessness if progress stagnates. Supervisors should recognize his self-driven nature as both a motivator and a potential source of friction in stagnant environments.
          </p>

          <h4>Do's and Don'ts</h4>

          <h4 className="text-dark">Do:</h4>
          <ol>
            <li><strong>Encourage Autonomy:</strong> Provide clear objectives but allow space for self-directed problem-solving.</li>
            <li><strong>Foster Collaborative Innovation:</strong> Engage him in brainstorming roles where his persuasive skills can thrive.</li>
            <li><strong>Balance Structure with Flexibility:</strong> Offer frameworks to satisfy his systematic side while permitting exploratory freedom.</li>
            <li><strong>Acknowledge Progress Needs:</strong> Regularly revisit goals to align with his desire for forward-moving environments.</li>
          </ol>

          <h4 className="text-dark">Don’t:</h4>
          <ol>
            <li><strong>Micromanage Decisions:</strong> Avoid excessive oversight; it may trigger defensiveness or stifle his independent streak.</li>
            <li><strong>Impose Unilateral Changes:</strong> Sudden, non-consultative shifts might heighten restlessness or dissatisfaction.</li>
            <li><strong>Dismiss His Input:</strong> Disregarding his persuasive ideas could lead to diminished engagement.</li>
            <li><strong>Overlook His Need for Growth:</strong> Stagnant roles risk triggering discontent; ensure visible pathways for advancement.</li>
          </ol>

          <h4>Behaviour Predictions</h4>
          <ol>
            <li><strong>Proactively Identify Improvements:</strong> Leverage curiosity to spot inefficiencies and advocate for iterative solutions.</li>
            <li><strong>Champion Collaborative Solutions:</strong> Use persuasive communication to rally cross-functional support for initiatives.</li>
            <li><strong>Experience Restlessness in Routine:</strong> Exhibit sporadic spontaneity when processes feel stagnant or undynamic.</li>
            <li><strong>Balance Enthusiasm with Caution:</strong> Approach high-stakes decisions with initial restraint, later pivoting to assertive action.</li>
          </ol>

          <h4>Strengths and Challenges:</h4>
          <div className="strengths-challenges">
            <p><strong>Strengths:</strong></p>
            <ul style={{ marginTop: "0px" }}>
              <li>Proactive problem-solving through inquisitive exploration.</li>
              <li>Persuasive collaboration balancing enthusiasm with restraint.</li>
              <li>Adaptable independence in dynamic scenarios.</li>
            </ul>

            <p><strong>Challenges:</strong></p>
            <ul style={{ marginTop: "0px" }}>
              <li>Balancing spontaneity with thorough planning.</li>
              <li>Managing discontent in stagnant conditions.</li>
              <li>Reconciling quick decisions with long-term consistency.</li>
            </ul>
          </div>

          <h4>Summary</h4>
          <p>
            Atanu’s strengths flourish in settings valuing inventive problem-solving and collaborative dynamism, where his curiosity and persuasive confidence drive meaningful contributions. Environments encouraging autonomy and iterative growth will harness his decisiveness and systematic leanings effectively. Conversely, overly rigid or static contexts risk triggering his restlessness, leading to frustration or impulsive pivots.
          </p>
        </div>
      </div> */}
    </>
  );
}

export default NewDetailedPersonality;